import React from "react";
import "./../../css/NotLogin.scss";
import AlexaLogoDark from "assets/alexa_logo.svg";
import AlexaLogoLight from "assets/img_light_theme/alexa_logo.svg";
import AlexaIconSmall from "assets/small_alexa.svg";
import { ThemeContext, themes } from "./../../theme-context";
import { LocalizationContext } from "./../../localization-context";
import { AlexaCommon } from "utils/Common";
import { SynapseMessenger } from "pages/Synapse";

const autoBind = require("auto-bind");

class NotLogin extends React.Component {
  intervalId = 0;

  /**
   *
   * @param {*} props
   * props.isSynapseLoggedIn
   */
  constructor(props) {
    super(props);
    this.state = {
      isShowAddonText: false,
      device_code: "",
      user_code: "",
      verification_url: "https://amazon.com/us/code",
      error_code: "",
      interval: 30,
    };
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_SHOW_LOGIN_ADDON_TEXT,
      "1",
      (data = {}) => {
        this.setState({ isShowAddonText: true });
      }
    );

    this.textArea = React.createRef();
    autoBind(this);
  }

  alexaGetAuthCode(options = this.defaultOption) {
    AlexaCommon.getCBLCodeToDisplay()
      .then((res) => {
        console.log(JSON.stringify(res));
        this.setState(
          {
            device_code: res.device_code,
            verification_url: res.verification_uri,
            user_code: res.user_code,
            interval: res.interval,
            error_code: "",
          },
          () => {
            this.intervalId = setInterval(this.makeDeviceTokenRequest, 5000);
          }
        );
      })
      .catch((err) => {
        console.log("errror while fetching CBL code to display" + err);
      });
  }

  copyToClipboard = (e) => {
    var textField = document.createElement("textarea");
    textField.innerText = this.state.user_code;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  makeDeviceTokenRequest() {
    console.log("hit device token request");
    let that = this;
    AlexaCommon.getDeviceToken(this.state.user_code, this.state.device_code)
      .then((res) => {
        clearInterval(that.intervalId);
        console.log("device token success" + JSON.stringify(res));
        localStorage.setItem("refreshToken", res.refresh_token);
        localStorage.setItem("token", res.access_token);
        SynapseMessenger.refreshPage();
      })
      .catch((err) => {
        console.log("errror while fetching device token request" + err);
        var errorCode = JSON.parse(err.message).error;
        switch (errorCode) {
          //case 'authorization_pending':
          case "invalid_code_pair":
            clearInterval(that.intervalId);
            this.setState({ error_code: errorCode });
            break;
          default:
            break;
        }
      });
  }

  onGuestLogin() {
    window.SynapseMessenger.GuestLogin();
  }

  openVerificationURL() {
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.OPEN_URL,
      this.state.verification_url
    );
  }

  renderLoginGuestPanel() {
    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="login-as-guest-wrapper">
            <div className="alexa-flex-column-jleft alexa-settings-wrapper">
              <div
                className="alexa-settings-title-text"
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                }}
              >
                {values.razerIDRequired}
              </div>
              <div
                className="alexa-settings-subtitle-text"
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                }}
              >
                {values.mustLogin}
              </div>
              <div
                className="login-button alexa-btn-green-overlay"
                style={{ marginTop: "20px" }}
                onClick={this.onGuestLogin}
              >
                <div className="alexa-btn-green alexa-flex-column-center">
                  <span className="rzButton">{values.logIn}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
  renderCodePanel() {
    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="login-code-wrapper">
            <div className="alexa-flex-column-jleft alexa-settings-wrapper">
              <div
                className="alexa-settings-subtitle-text"
                style={{
                  marginTop: "20px",
                  fontSize: "16px",
                  textAlign: "center",
                }}
              >
                <span>
                  {values.CodebasedLinking &&
                    values.CodebasedLinking.instruction1}
                </span>
                <span
                  style={{ marginLeft: 5 + "px", fontSize: "16px" }}
                  className="alexa-underline-special-btn"
                  onClick={this.openVerificationURL}
                >
                  amazon.com/code
                </span>
                <span>
                  {" "}
                  {values.CodebasedLinking &&
                    values.CodebasedLinking.instruction2}
                </span>
              </div>
              <div
                className="alexa-settings-subtitle-text"
                style={{
                  marginTop: "40px",
                  fontSize: "40px",
                  textAlign: "center",
                }}
              >
                <span ref={this.textArea} onClick={this.copyToClipboard}>
                  {this.state.user_code}
                </span>
              </div>
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
  renderErrorPanel() {
    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="login-code-wrapper">
            <div className="alexa-flex-column-jleft alexa-settings-wrapper">
              <div
                className="alexa-settings-subtitle-text"
                style={{
                  marginTop: "20px",
                  fontSize: "16px",
                  textAlign: "center",
                }}
              >
                <span>The code has expired. Retry to generate a new code</span>
              </div>
              <div
                className="login-button alexa-btn-green-overlay"
                style={{ marginTop: "20px" }}
                onClick={this.alexaGetAuthCode}
              >
                <div className="alexa-btn-green alexa-flex-column-center">
                  <span className="rzButton">RETRY</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }

  getServerEnv() {
    if (process.env.REACT_APP_ENDPOINT !== "production") {
      return process.env.REACT_APP_ENDPOINT;
    }
    return null;
  }

  renderLoginUserPanel() {
    let addOnText = (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="alexa-session-expired-wrapper">
            <div className="session-expired-line session-expired-line-1">
              {values.loginSessionExpireLine1}
            </div>
            <div className="session-expired-line session-expired-line-2">
              {values.loginSessionExpireLine2}
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );

    let serverEnv = this.getServerEnv();

    let addOnTextContent = this.state.isShowAddonText ? addOnText : "";
    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="login-as-razer-user-wrapper">
            <div className="alexa-flex-column-center login-subtitle">
              <p>{values.notLoginSubTitleLine1}</p>
            </div>
            <div className="login-button alexa-btn-overlay">
              <div
                className="login-button-btn alexa-btn alexa-flex-row-center-jleft alexa-color-blue"
                onClick={() => this.alexaGetAuthCode()}
              >
                <div className="alexa-btn-text-wrapper">
                  <span className="alexa-btn-text">
                    {values.loginWithAlexa}
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div>
              <span>{values.SupportedRegions}</span>
              <table style={{ margin: "20px 0px 0px 175px" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      English (US)
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      Français (FR)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      English (AU)
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      Français (CA)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      English (CA)
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      Español (US)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      English (GB)
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      Español (ES)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      English (IN)
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      Español (MX)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      <span>Deutsch (DE)</span>
                    </td>
                    <td style={{ width: "140px", textAlign: "left" }}>
                      日本語(JP)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {addOnTextContent}
            <div style={{ marginTop: "10px" }}>
              <span>{values.VoiceNote}</span>
            </div>
            {serverEnv && (
              <div
                style={{ marginTop: "20px", fontSize: "12px", color: "#666" }}
              >
                <span>{serverEnv}</span>
              </div>
            )}
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }

  render() {
    let theme = this.context;
    let AlexaLogo = theme === themes.light ? AlexaLogoLight : AlexaLogoDark;
    let loginGuestPanel = this.renderLoginGuestPanel();
    let loginUserPanel = this.renderLoginUserPanel();
    let codeUserPanel = this.renderCodePanel();
    let loginPanel =
      this.state.error_code === ""
        ? !this.props.isSynapseGuestLoggedIn
          ? this.state.device_code === ""
            ? loginUserPanel
            : codeUserPanel
          : loginGuestPanel
        : this.renderErrorPanel();
    let loginWrapperCssClassName = !this.props.isSynapseGuestLoggedIn
      ? this.state.device_code === ""
        ? "login-wrapper-as-user"
        : "login-wrapper-as-cbl"
      : "login-wrapper-as-guest";

    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="alexa-flex-column-center login-container">
            <div
              className={`aleax-absolute-vertical-center ${loginWrapperCssClassName}`}
            >
              <div className="login-title">
                <div className="alexa-icon-wrapper">
                  <img src={AlexaLogo} />
                </div>
              </div>
              {loginPanel}
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
}
NotLogin.contextType = ThemeContext;
export default NotLogin;
